var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSharp = function SvgStarSharp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M11.732 17.637a.5.5 0 0 1 .536 0l4.277 2.717a.5.5 0 0 0 .756-.53l-1.152-5.201a.5.5 0 0 1 .15-.478l3.86-3.52a.5.5 0 0 0-.292-.867l-5.033-.45a.5.5 0 0 1-.42-.311l-1.95-4.845a.5.5 0 0 0-.928 0l-1.95 4.845a.5.5 0 0 1-.42.311l-5.033.45a.5.5 0 0 0-.293.867l3.86 3.52a.5.5 0 0 1 .151.478l-1.152 5.2a.5.5 0 0 0 .756.53z"
  })));
};
export default SvgStarSharp;